<template>
  <v-card
    class="py-3 px-2"
    outlined
  >
    <v-card-title class="light-blue--text headline">Late Payments</v-card-title>

    <v-card-text>
      <template v-if="propertiesRentLoading || propertiesLoading">
        <div class="text-center">
          <v-progress-circular color="light-blue" indeterminate/>
        </div>
      </template>
      <template v-else>
        <template v-if="Object.keys(rentList).length">

          <template v-for="(latePayments, key, index) in rentList">
            <v-row no-gutters
                   :key="key+'late-payments'"
                   align="center"
                   justify="space-between"
            >
              <v-col class="pt-0" cols="12" lg="9" xl="">
                <v-row align="center">
                  <v-col class="pt-0" cols="2" xl="1">
                    <v-icon large color="error" :class="$props.darkMode ? '' : 'darken-1'">mdi-alert</v-icon>
                  </v-col>
                  <v-col class="pt-0">
                    <div class=" d-flex"> {{ properties[key].addressLineOne }}, {{ properties[key].city }} {{ properties[key].state }}, {{ properties[key].zip  }}</div>
                    <div :class="$props.darkMode ? '' : 'text--darken-1'" class="error--text">  <strong >{{latePayments}} Missing Payment{{latePayments > 1 ? 's' : ''}}</strong></div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" lg="3" xl="2">
                <v-btn
                  color="light-blue"
                  dark
                  block
                  :small="$vuetify.breakpoint.mdAndUp"
                  elevation="0"
                  tile
                  :to="'/properties/detail/'+key"
                >
                  View
                </v-btn>
              </v-col>
            </v-row>
            <v-divider v-if="index !== Object.keys(rentList).length -1" class="my-3" :key="key+'late-payments-divider'"></v-divider>

          </template>
        </template>
        <template v-else>
          <v-row
            align="center"
            justify="space-between"
          >
            <v-col class="py-0">
              <div class="d-flex">
                <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                All payments are up to date.
              </div>
            </v-col>
          </v-row>
        </template>
      </template>

    </v-card-text>
  </v-card>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "LatePaymentsList",
    computed: {
      rentList() {
        let lateProperties = this.filteredProperties();
        let result = {};
         if(lateProperties){
           Object.keys(lateProperties).forEach((key) => {
             result[key] = lateProperties[key]
           })
         }
         return result;
      },
      ...mapGetters([
        'properties',
        'propertiesRent',
        'propertiesRentLoading',
        'propertiesLoading',
      ]),

    },
    props:{
      darkMode:{
        type:Boolean,
        default: false
      },
    },
    methods: {
      checkPayments(startDate, rentData) {
        let missingPayments = 0;
        let startYear = parseInt(startDate.substr(0, 4));
        let startMonth = parseInt(startDate.substr(5, 2));

        let currentYear = parseInt(moment().format('YYYY'));
        let currentMonth = parseInt(moment().format('MM'));

        if (rentData !== undefined) {
          for (var y = startYear; y <= currentYear; ++y) {
            for (var m = 1; m <= 12; ++m) {
              if (
                //is current year and start year
                (y === currentYear && y === startYear && m >= startMonth && m < currentMonth) ||
                //is current year and not start year
                (y === currentYear && y !== startYear && m < currentMonth) ||
                //is not current year and also is not start year
                (y !== currentYear && y !== startYear) ||
                //is not current year and is start year
                (y !== currentYear && y === startYear && m >= startMonth)) {
                if (Object.prototype.hasOwnProperty.call(rentData, y)) {
                  if (Object.prototype.hasOwnProperty.call(rentData[y], m)) {
                    if (rentData[y][m] !== true) {
                      ++missingPayments;
                    }
                  }
                }
              }
            }
          }
        }
        return missingPayments;
      },
      filteredProperties() {
        let totalMissingPayments = {};
        Object.keys(this.propertiesRent).forEach((id) => {
          let mp = this.checkPayments(this.properties[id].startDate, this.propertiesRent[id]);
          if (mp) {
            totalMissingPayments[id] = mp
          }
        });
        return totalMissingPayments;
      },
      ...mapActions([
        'setPropertiesRent',
      ]),

    },
    created() {
      this.setPropertiesRent();
    },
    watch: {},


  }
</script>

<style scoped>

</style>